import ImgSpot from '../../components/ImgSpot/ImgSpot';
import './Impressum.css';
import img from '../../assets/VdHR©lisa_hinder_302.jpg';
import { useEffect } from 'react';

function Impressum() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div style={{ height: 'calc(100px + 16vh)' }}></div>
      <h1>Impressum</h1>
      <div className="footerImpressumDiv">
        <div className="footerImpressumDivLinks">
          <div>
            <b>Alleinvertretungsberechtigte Vorstandsmitglieder:</b>
            <p>Wolfgang Seesko | w.seesko@vdhr.info</p>
            <p>Anouschka Trocker | a.trocker@vdhr.info</p>
          </div>
          <br></br>
          <div>
            <b>Geschäftsführende Vorstandsmitglieder:</b>
            <p>Christine Nagel | ch.nagel@vdhr.info</p>
            <p>Felix Partenzi | f.partenzi@vdhr.info</p>
            <br></br>
          </div>
          <div>
            <b>Verband der HörspielRegie e.V.</b>
            <p>c/o A. Trocker</p>
            <p>Esmarchstraße 17</p>
            <p>10407 Berlin</p>
          </div>
        </div>
        <div>
          <br></br>
          <p>Registergericht: Amtsgericht Charlottenburg (Berlin)</p>
          <p>Registernummer: VR 26709</p>
          <p>
            Die in diesem Internet-Angebot veröffentlichten Beiträge sind
            urheberrechtlich geschützt. Alle Rechte bleiben vorbehalten. Außer
            zu kommerziellen Zwecken ist bei Quellenangabe ein Nachdruck
            gestattet. Wir bitten um ein Belegexemplar.
          </p>
          <p>
            Haftungshinweis: Trotz sorgfältiger inhaltlicher Kontrolle
            übernehmen wir keine Haftung für die Inhalte externer Links. Für den
            Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber
            verantwortlich.
          </p>
        </div>
        <div>
          <br></br>
          <br></br>
          <div>
            <p style={{ display: 'inline' }}>Fotos </p>
            <a href="https://www.lisahinder.de/">Lisa Hinder</a>
          </div>
          <div>
            <p style={{ display: 'inline' }}>Design </p>
            <a href="http://caruccio.de/">Caruccio Design</a>
          </div>
        </div>
      </div>
      <ImgSpot img={img}></ImgSpot>
    </>
  );
}

export default Impressum;
